import { Text, View } from 'react-native'

export interface ActivityEntry {
  id: string
  label: string
  detail?: string
  timestamp: string
  delta?: string
  isNegative?: boolean
}

interface ActivityListProps {
  entries: ActivityEntry[]
}

export function ActivityList({ entries }: ActivityListProps) {
  return (
    <View>
      {entries.map((entry, index) => (
        <View
          key={entry.id}
          className={`flex-row items-start gap-3 py-4 ${index < entries.length - 1 ? 'border-b border-border' : ''}`}
        >
          <View className="min-w-0 flex-1 gap-0.5">
            <Text className="text-sm font-semibold text-primary">{entry.label}</Text>
            {entry.detail ? (
              <Text className="text-xs font-normal text-muted" numberOfLines={1}>{entry.detail}</Text>
            ) : null}
          </View>

          <View className="shrink-0 items-end gap-0.5">
            <Text className="text-xs font-normal text-muted">{entry.timestamp}</Text>
            {entry.delta ? (
              <Text
                className={`text-sm font-medium ${entry.isNegative ? 'text-accent' : 'text-primary'}`}
              >
                {entry.delta}
              </Text>
            ) : (
              <Text className="text-sm font-normal text-muted">—</Text>
            )}
          </View>
        </View>
      ))}
    </View>
  )
}